import { Controller } from "@hotwired/stimulus";

// The mobile nav drawer is driven by a hidden checkbox, so it slides open and
// closed with or without JavaScript. The label hamburger, the backdrop tap, and
// the scroll lock are all CSS. This only adds Escape to close, which CSS cannot do.
export default class extends Controller {
  static targets = ["toggle"];

  close() {
    this.toggleTarget.checked = false;
  }
}
